import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-6" }
const _hoisted_2 = ["onDblclick"]
const _hoisted_3 = { class: "full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block_select = _resolveComponent("editable-block-select")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_editable_block, {
      "model-value": _ctx.companyAddress,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:company-address', {..._ctx.tenant, settings: { company: { address: $event }}}))),
      title: "Address"
    }, {
      default: _withCtx(({ editState, editingRef }) => [
        _createElementVNode("div", {
          class: "company-address",
          onDblclick: ($event: any) => (editingRef.value = true)
        }, [
          (!editingRef.value)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 0,
                selector: ".company-address",
                "tooltip-value": "Double click to edit"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_editable_block_input, {
              label: "Street",
              modelValue: editState.street,
              "onUpdate:modelValue": ($event: any) => ((editState.street) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_editable_block_input, {
              label: "Number + addition",
              modelValue: editState.street_number,
              "onUpdate:modelValue": ($event: any) => ((editState.street_number) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_editable_block_input, {
              label: "Zip code",
              modelValue: editState.zipcode,
              "onUpdate:modelValue": ($event: any) => ((editState.zipcode) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_editable_block_input, {
              label: "City",
              modelValue: editState.city,
              "onUpdate:modelValue": ($event: any) => ((editState.city) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_editable_block_input, {
              label: "County / province",
              modelValue: editState.region,
              "onUpdate:modelValue": ($event: any) => ((editState.region) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_editable_block_select, {
              modelValue: editState.country,
              "onUpdate:modelValue": ($event: any) => ((editState.country) = $event),
              options: _ctx.countryDictionaryOptions,
              label: "Country"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ])
        ], 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}